export default function parseCurrencyStringToFloat(formattedValue: string): number {
  const withoutSymbol = formattedValue.replaceAll('R$', '');
  const removeDot = withoutSymbol.replace('.', '');
  const replaceComaWithDot = removeDot.replace(',', '.');
  const removeSpaces = replaceComaWithDot.replace(/\s/g, '');

  return Number(removeSpaces);
}
